export default "__VITE_ASSET__YkKIXfWI__"